import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Tabs, Tab, Box } from '@material-ui/core'
import { Container } from '../../../../components'
import { PropertyUnitsTree } from './Components/PropertyUnitsTree'
import { usePropertyDetails } from '../hooks/usePropertyDetails'
import { TokenManagement } from './Components/Tokens/TokenManagement'
import { Billing } from './Components/PropertyInvoices/Billing'

export const PropertyDetail = () => {
    const { id } = useParams<{ id: string }>()
    const [activeTab, setActiveTab] = useState(0)

    const { property } = usePropertyDetails(id)

    const handleTabChange = (
        event: React.ChangeEvent<{}>,
        newValue: number,
    ) => {
        setActiveTab(newValue)
    }

    if (!property) return <div>Loading...</div>

    const renderTabContent = () => {
        switch (activeTab) {
            case 0:
                return <PropertyUnitsTree propertyId={id} />
            case 1:
                return <Billing property={property} />
            case 2:
                return <TokenManagement />
            default:
                return <PropertyUnitsTree propertyId={id} />
        }
    }

    return (
        <Container style={{ flexDirection: 'column' }}>
            <Box mb={2}>
                <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab label="Units & Buildings" />
                    <Tab label="Billing" />
                    <Tab label="Token Management" />
                </Tabs>
            </Box>

            {renderTabContent()}
        </Container>
    )
}
